/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Property from './Property';

/**
 * The PaginatedPropertiesResponse model module.
 * @module model/PaginatedPropertiesResponse
 * @version 1.0.0
 */
class PaginatedPropertiesResponse {
    /**
     * Constructs a new <code>PaginatedPropertiesResponse</code>.
     * @alias module:model/PaginatedPropertiesResponse
     */
    constructor() { 
        
        PaginatedPropertiesResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedPropertiesResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedPropertiesResponse} obj Optional instance to populate.
     * @return {module:model/PaginatedPropertiesResponse} The populated <code>PaginatedPropertiesResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedPropertiesResponse();

            if (data.hasOwnProperty('total_count')) {
                obj['total_count'] = ApiClient.convertToType(data['total_count'], 'Number');
            }
            if (data.hasOwnProperty('current_page')) {
                obj['current_page'] = ApiClient.convertToType(data['current_page'], 'Number');
            }
            if (data.hasOwnProperty('per_page')) {
                obj['per_page'] = ApiClient.convertToType(data['per_page'], 'Number');
            }
            if (data.hasOwnProperty('properties')) {
                obj['properties'] = ApiClient.convertToType(data['properties'], [Property]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedPropertiesResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedPropertiesResponse</code>.
     */
    static validateJSON(data) {
        if (data['properties']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['properties'])) {
                throw new Error("Expected the field `properties` to be an array in the JSON data but got " + data['properties']);
            }
            // validate the optional field `properties` (array)
            for (const item of data['properties']) {
                Property.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * 全物件数
 * @member {Number} total_count
 */
PaginatedPropertiesResponse.prototype['total_count'] = undefined;

/**
 * 現在のページ
 * @member {Number} current_page
 */
PaginatedPropertiesResponse.prototype['current_page'] = undefined;

/**
 * 1ページあたりの件数
 * @member {Number} per_page
 */
PaginatedPropertiesResponse.prototype['per_page'] = undefined;

/**
 * @member {Array.<module:model/Property>} properties
 */
PaginatedPropertiesResponse.prototype['properties'] = undefined;






export default PaginatedPropertiesResponse;

